import type { ExcursionPage } from "../slug-excursions";
import stpaulvence from "@/assets/images/excursions/destinations/st-paul-vence.jpeg";

const page: ExcursionPage = {
  slug: "saint-paul-de-vence",
  hero: {
    title: "Excursion Saint‑Paul‑de‑Vence",
    subtitle:
      "Art, galeries et remparts : un joyau médiéval près de la Côte d’Azur.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: stpaulvence,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Remparts et ruelles de Saint‑Paul‑de‑Vence" },
      { text: "Galeries d’art, ateliers et artistes en résidence" },
      { text: "Fondation Maeght à proximité (option)" },
      { text: "Vues sur l’arrière‑pays et mer (par temps clair)" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Départ Cannes",
        description: "Route pittoresque vers l’arrière‑pays.",
      },
      {
        title: "Découverte du village",
        description: "Remparts, places, galeries.",
      },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "3 à 5 heures" },
      { label: "Départ", value: "Cannes" },
      { label: "Chaussures", value: "Sol pavé, prévoir confort" },
      { label: "Option", value: "Visite Fondation Maeght (selon horaires)" },
    ],
  },
};

export default page;
